import ToastHelper from './ToastHelper'

// Tai XML: nhan chuoi XML (invoice.xmlString tu find-by-lookup-code) va ten file.
// Chi chap nhan chuoi khong rong -> tranh truong hop truyen nham object ({lookupCode})
// khien blob thanh "[object Object]".
const DownloadXMLFileHelper = (xmlString, fileName = 'invoice') => {
  if (typeof xmlString !== 'string' || xmlString.trim() === '') {
    ToastHelper.showError('Không có dữ liệu XML để tải')
    return
  }

  const blob = new Blob([xmlString], { type: 'application/xml' })
  const downloadUrl = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = downloadUrl
  const safeName = String(fileName).replace(/[\\/:*?"<>|]/g, '_') || 'invoice'
  link.setAttribute('download', `${safeName}.xml`)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(downloadUrl)
}

export default DownloadXMLFileHelper
